import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Loadable from 'react-loadable';
import LazyLoad from '@ifeng/ui_pc_lazyLoad';
import { rel } from '../../../../../../utils/rel';
import errorBoundary from '@ifeng/errorBoundary';
import { formatImage } from '@ifeng/public_method';

const LoadWeibo = Loadable({
    loader: () => import('../weibo'),
    loading() {
        return <div />;
    },
});

class Wexin extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { qrCode, name, title, url, uid },
        } = this.props;

        return (
            <div className={styles.box}>
                <div className={styles.pic}>
                    <p>
                        <img src={formatImage(qrCode, 80, 80)} width="80" height="80" />
                    </p>
                    <p className={styles.text}>{name}</p>
                </div>
                <div className={styles.detail}>
                    <p>
                        <a href={url} target="_blank" title={title} rel={rel}>
                            {title}
                        </a>
                    </p>
                    <LazyLoad>
                        <LoadWeibo uid={uid} />
                    </LazyLoad>
                </div>
            </div>
        );
    }
}

export default errorBoundary(Wexin);
